import axios from 'axios';

export const claimPaymentService = {
    /** Claim Payment */
    createClaimPaymentsService: (data) => axios.post('/remittance', data, { auth: true }),

    editRemittanceService: (id, data) => axios.patch(`/remittance/${id}`, data, { auth: true }),

    getRemittanceService: (params) => axios.get('/remittance', { auth: true, params: params }),

    verifyRemittanceService: (ids) => axios.patch('/remittance/verify', { remittanceIds: ids }, { auth: true }),

    markReviewedService: (ids, reviewNote) =>
        axios.patch('/remittance/mark-reviewed', { remittanceIds: ids, reviewNote }, { auth: true }),

    /** Import ERAs from TL Clearinghouse now — same as the nightly sync; runs in the background on the server. */
    syncTlClearinghouseErasService: () => axios.post('/clearinghouse/poll/stedi/era', null, { auth: true }),

    getRemittanceByIdService: (id) => axios.get(`/remittance/${id}`, { auth: true }),

    getRemittanceByIdClaimsService: (id, params) => axios.get(`/remittance/${id}/claims`, { auth: true, params: params }),

    voidRemittanceService: (id, params) => axios.patch(`/remittance/${id}/void`, null, { auth: true, params: params }),

    massVoidRemittanceService: (data) => axios.patch('/remittance/mass-void', data, { auth: true }),

    deleteRemittanceService: (id) => axios.delete(`/remittance/${id}`, { auth: true }),

    getRemittanceTotalService: (params) => axios.get(`/remittance/totals`, { auth: true, params: params }),

    getClaimPaymentsService: (data) => axios.get('/claim', { auth: true, params: { ...data } }),

    getClaimPaymentFilteredService: (id, data) => axios.get(`/remittance/${id}/payable-claims`, { auth: true, params: { ...data } }),

    editClaimPmtInfoService: (payload) =>
        axios.patch(
            `/claim/${payload?.body?.claimId}/remittance/${payload?.body?.remittanceId}`,
            { ...payload?.body?.body },
            { auth: true }
        ),

    // editClaimPmtInfoService: ({id, body}) => axios.patch(`/claim/${id}`, {...body}, {auth:true}),

    appealClaimPmtService: ({ id, description, mark }) =>
        axios.post(`/claim/${id}/pmt/appeal`, { description: description, mark: mark }, { auth: true }),

    payInFullClaimService: ({ id, remittanceId, paymentRef }) =>
        axios.post(`/claim/${id}/pmt/remittance/${remittanceId}`, { ...paymentRef }, { auth: true }),
    // payInFullClaimService: ({id, paymentRef}) => axios.post(`/claim/${id}/pmt`, {...paymentRef}, {auth:true}),

    payInFullClaimBillingService: ({ id, billId, remittanceId, paymentRef }) =>
        axios.post(`/claim/${id}/pmt/bill/${billId}/remittance/${remittanceId}`, { ...paymentRef }, { auth: true }),

    removeClaimFromRemittanceService: ({ claimId, remittanceId }) =>
        axios.delete(`/claim/${claimId}/remittance/${remittanceId}`, { auth: true }),
    /** End */
};
